import { axios } from '../../clients/axios'
import nodeFormData from 'form-data'
import { dayjs } from '../../util/date'
import FileDownload from 'js-file-download'
import { FORM_DATA_HEADERS } from './config'

const pdcHeaders = [
  { value: 'refNo', text: 'ID' },
  { value: 'paymentRefNo', text: 'PRID' },
  { value: 'category', text: 'Category' },
  { value: 'dateCreated', text: 'Date Received' },
  { value: 'unitName', text: 'Unit' },
  { value: 'tenantName', text: 'Tenant' },
  { value: 'checkNumber', text: 'Check No.' },
  { value: 'amount', text: 'Amount' },
  { value: 'dueDate', text: 'Check Date' },
  { value: 'status', text: 'Status' },
  { value: 'actions', text: 'Actions' }
]

function getTenantName(tenant) {
  let displayName = ''
  if (tenant.firstName) {
    displayName += tenant.firstName + ' '
    if (tenant.lastName) {
      displayName += tenant.lastName + ' '
    }
  } else {
    return (displayName = tenant.username)
  }

  return displayName
}

export default {
  namespaced: true,
  state: {
    pdcs: [],
    bedPdcs: [],
    duePdcs: [],
    openProcess: false,
    batchImportPreview: []
  },
  getters: {
    getPdcs: (state, getters, rootState, rootGetters) => {
      const aliases = rootGetters['users/getAliases']
      const units = rootGetters['units/getUnitsFlat']
      return state.pdcs.map((pdc) => {
        const alias = aliases.find(
          (a) => a.tenantId === pdc.tenant_details.userId
        )
        const bedId =
          (pdc.lease_details &&
            (pdc.lease_details.status === 'active' ||
              pdc.lease_details.status === 'expired') &&
            pdc.lease_details.bedId.toString()) ||
          pdc.tenant_details.currentBedId

        const unit = units.find(
          (u) => u.bedId === parseInt(pdc.lease_details.bedId)
        )

        return {
          ...pdc,
          dateCreated:
            (pdc.dateCreated && dayjs(pdc.dateCreated).format('M/DD/YYYY')) ||
            'N/A',
          dueDate:
            (pdc.dueDate && dayjs(pdc.dueDate).format('M/DD/YYYY')) || 'N/A',
          startDate:
            (pdc.startDate && dayjs(pdc.startDate).format('M/DD/YYYY')) ||
            'N/A',
          endDate:
            (pdc.endDate && dayjs(pdc.endDate).format('M/DD/YYYY')) || 'N/A',
          tenantName:
            (alias && alias.name) ||
            (pdc.tenant_details.firstName && pdc.tenant_details.lastName
              ? pdc.tenant_details.firstName + ' ' + pdc.tenant_details.lastName
              : pdc.tenant_details.username),
          bedId: bedId,
          paymentRefNo: pdc.payment_details && pdc.payment_details.refNo,
          unitName: unit && unit.bedName
        }
      })
    },
    getHeaders: () => {
      return pdcHeaders
    },
    getDuePdcs: (state, getters, rootState, rootGetters) => {
      const aliases = rootGetters['users/getAliases']

      return state.duePdcs.map((pdc) => {
        const alias = aliases.find((a) => a.tenantId === pdc.tenantId)
        pdc.dueDate = dayjs(pdc.dueDate).format('MMM D, YYYY')
        pdc.tenantName =
          (alias && alias.name) || getTenantName(pdc.tenant_details)
        pdc.bedName = pdc.bed_details ? pdc.bed_details.bedName : ''
        return pdc
      })
    },
    getBatchImportPreview: (state) => {
      return state.batchImportPreview
    }
  },
  mutations: {
    fetchPdcs(state, pdcs) {
      state.pdcs = pdcs
    },
    fetchDuePdcs(state, pdcs) {
      state.duePdcs = pdcs
    },
    fetchBatchImportPreview(state, pdcs) {
      state.batchImportPreview = pdcs
    }
  },
  actions: {
    async fetchPdcsAction(context, params) {
      let uri = `${process.env.VUE_APP_API_URL}/pdcs/search`

      const paramsToSend = params
      // remove empty string / falsy attributes
      Object.keys(paramsToSend).forEach(
        (k) => !paramsToSend[k] && delete paramsToSend[k]
      )
      paramsToSend.page = (params.page || 1) - 1

      const pdcs = await axios.get(uri, {
        params: paramsToSend,
        withCredentials: true
      })

      context.commit('fetchPdcs', pdcs.data.data)

      return {
        limit: params.limit,
        count: pdcs.data.count
      }
    },
    async createPDCAction(context, params) {
      const form = new nodeFormData()
      const {
        propertyId,
        tenantId,
        checkNumber,
        amount,
        dueDate,
        bank,
        routingNumber,
        accountNumber,
        description,
        attachments,
        startDate,
        endDate,
        leaseId,
        category
      } = params

      if (attachments) {
        await attachments.map((file) => {
          form.append('attachments', file)
        })
      }

      form.append('propertyId', propertyId)
      form.append('tenantId', tenantId)
      form.append('checkNumber', checkNumber)
      form.append('amount', amount)
      form.append('dueDate', dueDate)
      form.append('startDate', startDate)
      form.append('endDate', endDate)
      form.append('bank', bank)
      // form.append('branch', branch)
      form.append('routingNumber', routingNumber)
      form.append('accountNumber', accountNumber)
      form.append('category', category)
      form.append('description', description)
      form.append('leaseId', leaseId)

      const pdc = await axios.post(
        `${process.env.VUE_APP_API_URL}/pdcs`,
        form,
        {
          headers: FORM_DATA_HEADERS,
          withCredentials: true
        }
      )

      return Promise.resolve(pdc)
    },
    async setOpenAction(context, params) {
      try {
        const { pdcId } = params

        const pdc = await axios.put(
          `${process.env.VUE_APP_API_URL}/pdcs/${pdcId}/open`,
          {},
          {
            withCredentials: true
          }
        )

        return Promise.resolve(pdc)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async setProcessedAction(context, params) {
      const form = new nodeFormData()
      try {
        const {
          pdcId,
          description,
          attachments,
          currentAttachments = []
        } = params

        form.append('pdcId', pdcId)
        form.append('description', description)
        form.append('currentAttachments', JSON.stringify(currentAttachments))
        if (attachments) {
          attachments.map((file) => {
            form.append('attachments', file)
          })
        }

        const pdc = await axios.put(
          `${process.env.VUE_APP_API_URL}/pdcs/${pdcId}/processed`,
          form,
          {
            headers: FORM_DATA_HEADERS,
            withCredentials: true
          }
        )

        return Promise.resolve(pdc)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async setClearedAction(context, params) {
      const form = new nodeFormData()
      const {
        pdcId,
        description,
        attachments,
        currentAttachments = []
      } = params

      form.append('pdcId', pdcId)
      form.append('description', description)
      form.append('currentAttachments', JSON.stringify(currentAttachments))
      if (attachments) {
        attachments.map((file) => {
          form.append('attachments', file)
        })
      }

      const pdc = await axios.put(
        `${process.env.VUE_APP_API_URL}/pdcs/${pdcId}/cleared`,
        form,
        {
          headers: FORM_DATA_HEADERS,
          withCredentials: true
        }
      )

      return Promise.resolve(pdc)
    },
    async setNotClearedAction(context, params) {
      const form = new nodeFormData()
      const {
        pdcId,
        description,
        attachments,
        currentAttachments = []
      } = params

      form.append('pdcId', pdcId)
      form.append('description', description)
      form.append('currentAttachments', JSON.stringify(currentAttachments))
      if (attachments) {
        attachments.map((file) => {
          form.append('attachments', file)
        })
      }

      const pdc = await axios.put(
        `${process.env.VUE_APP_API_URL}/pdcs/${pdcId}/notCleared`,
        form,
        {
          headers: FORM_DATA_HEADERS,
          withCredentials: true
        }
      )

      return Promise.resolve(pdc)
    },
    async setCanceledAction(context, params) {
      const form = new nodeFormData()
      const {
        pdcId,
        description,
        attachments,
        currentAttachments = []
      } = params

      form.append('pdcId', pdcId)
      form.append('description', description)
      form.append('currentAttachments', JSON.stringify(currentAttachments))
      if (attachments) {
        attachments.map((file) => {
          form.append('attachments', file)
        })
      }

      const pdc = await axios.put(
        `${process.env.VUE_APP_API_URL}/pdcs/${pdcId}/canceled`,
        form,
        {
          headers: FORM_DATA_HEADERS,
          withCredentials: true
        }
      )

      return Promise.resolve(pdc)
    },
    async fetchDuePdcsAction(context) {
      let uri = `${process.env.VUE_APP_API_URL}/pdcs/due`

      const pdcs = await axios.get(uri, { withCredentials: true })
      context.commit('fetchDuePdcs', pdcs.data)

      return pdcs.data.map((pdc) => {
        pdc.dueDate = dayjs(pdc.dueDate).format('YYYY-MM-DD')
        return pdc
      })
    },
    async sendMessageNotClearedAction(context, params) {
      try {
        const { subject, emailMessage, smsMessage, tenantId } = params
        let uri = `${process.env.VUE_APP_API_URL}/pdcs/sendMessageNotCleared`

        const pdc = await axios.post(
          uri,
          {
            subject,
            emailMessage,
            smsMessage,
            tenantId
          },
          {
            withCredentials: true
          }
        )

        return Promise.resolve(pdc)
      } catch (err) {
        let response = 'There was an error processing your request'
        if (err.response.status === 403) {
          response = 'You are not authorized to send a message'
        }
        return Promise.reject(response)
      }
    },
    async updatePDCAction(context, params) {
      try {
        const form = new nodeFormData()
        const {
          pdcId,
          routingNumber,
          accountNumber,
          checkNumber,
          description,
          bank,
          attachments,
          dueDate
        } = params

        const headers = {
          'Content-Type': 'multipart/form-data'
        }

        if (attachments) {
          await attachments.map((file) => {
            form.append('attachments', file)
          })
        }

        form.append('pdcId', pdcId)
        form.append('checkNumber', checkNumber)
        form.append('bank', bank)
        form.append('routingNumber', routingNumber)
        form.append('accountNumber', accountNumber)
        form.append('description', description)
        form.append('dueDate', dueDate)

        const pdc = await axios.put(
          `${process.env.VUE_APP_API_URL}/pdcs/update`,
          form,
          {
            headers: headers,
            withCredentials: true
          }
        )

        return Promise.resolve(pdc)
      } catch (err) {
        return Promise.reject(err)
      }
    },
    async uploadPDCImportFile(context, params) {
      const form = new nodeFormData()
      form.append('file', params.file)

      const headers = {
        'Content-Type': 'multipart/form-data'
      }

      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/pdcs/batch/preview`,
          form,
          {
            headers: headers,
            withCredentials: true
          }
        )

        context.commit('fetchBatchImportPreview', res.data)
        return Promise.resolve(res.data)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async submitBatchImportEntries(context, params) {
      const { entries } = params

      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/pdcs/batch/data`,
          {
            data: entries.filter((entry) => entry && entry.selected)
          },
          {
            withCredentials: true
          }
        )
        return Promise.resolve(res)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async approvePDCAction(context, params) {
      const { pdcId } = params

      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/pdcs/approve`,
        {
          pdcId
        },
        {
          withCredentials: true
        }
      )

      return result.data
    },
    async rejectPDCAction(context, params) {
      const { pdcId } = params

      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/pdcs/reject`,
        {
          pdcId
        },
        {
          withCredentials: true
        }
      )

      return result.data
    },
    async generatePDCReportAction(context, params) {
      try {
        const {
          tenantIds,
          receivedStartDate,
          receivedEndDate,
          receivedAllDates,
          paidStartDate,
          paidEndDate,
          paidAllDates,
          statuses,
          fileType,
          clearedStartDate,
          clearedEndDate,
          clearedAllDates
        } = params

        const PDCReport = await axios.post(
          `${process.env.VUE_APP_API_URL}/pdcs/report`,
          {
            tenantIds,
            receivedStartDate,
            receivedEndDate,
            receivedAllDates,
            paidStartDate,
            paidEndDate,
            paidAllDates,
            statuses,
            fileType,
            clearedStartDate,
            clearedEndDate,
            clearedAllDates
          },
          {
            withCredentials: true,
            responseType: 'blob'
          }
        )
        FileDownload(PDCReport.data, `Report.${fileType}`)

        return Promise.resolve(PDCReport.data)
      } catch (err) {
        return Promise.reject(err.response)
      }
    },
    async batchApprovePDCs(context, params) {
      const { pdcs } = params

      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/pdcs/batch/approve`,
        {
          pdcs
        },
        {
          withCredentials: true
        }
      )

      return result.data
    },
    async batchRejectPDCs(context, params) {
      const { pdcs } = params

      const result = await axios.post(
        `${process.env.VUE_APP_API_URL}/pdcs/batch/reject`,
        {
          pdcs
        },
        {
          withCredentials: true
        }
      )

      return result.data
    }
  }
}
